import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DialogConfig } from 'src/app/core/components/dialog/dialog-config';
import { DialogRef } from 'src/app/core/components/dialog/dialog-ref';
import { Company, CompanyLight } from 'src/app/lem/models/companies/company';
import { CompaniesDepartment, CompanyDepartmentType } from 'src/app/lem/models/departments/departments';
import { DepartmentsService } from '../../service/departments.service';

@Component({
  selector: 'app-modal-department-form',
  templateUrl: './modal-department-form.component.html',
  styleUrls: ['./modal-department-form.component.css']
})
export class ModalDepartmentFormComponent implements OnInit {

  form : FormGroup;
  companiesList : Company[] = [];
  types : CompanyDepartmentType[] = [];
  departmentsList : CompaniesDepartment[] = [];
  isEnabled: boolean = false
  errors : boolean = false;
  companiesDepartmentSelected : CompaniesDepartment;
  companySelected: CompanyLight;
  typeSelected: CompanyDepartmentType;
  parentSelected : CompaniesDepartment;
  formEdit ;
  parentDepartments: CompaniesDepartment[] = [];


  constructor(
    private formBuilder : FormBuilder,
    private modalRef : DialogRef,
    private departmentsService : DepartmentsService,
    private dialogConfig : DialogConfig,
    private dialogRef : DialogRef
    ) { }

  ngOnInit() {

    this.types = this.dialogConfig.data.types;
    this.companiesDepartmentSelected = this.dialogConfig.data.department;
    this.companiesList = this.dialogConfig.data.companies;
    this.departmentsList = this.dialogConfig.data.dipartmentsList;
    this.preselectForm();

    this.parentDepartments = this.departmentsList.filter(el => el.company.id === this.companiesDepartmentSelected?.company?.id && el.id !== this.companiesDepartmentSelected.id);

    this.form = this.formBuilder.group({
      company : [this.companySelected,Validators.required],
      name : [this.typeSelected.name, [Validators.required,Validators.maxLength(50)]],
      description : [this.typeSelected.description,[Validators.required,Validators.maxLength(255)]],
      parent : [this.parentSelected],
    })
  }



  changeCompany(company: Company){
    if(company){
      this.companySelected = {id:'',name:''};
      this.companySelected.id = company.id;
      this.companySelected.name = company.name;
    } else {
      this.companySelected = undefined;
    }

    this.form.get('parent').setValue(null);
    this.parentDepartments = this.departmentsList.filter(el => el.company.id === company?.id && el.id !== this.companiesDepartmentSelected?.id);
  }

  changeDepartment(department: CompaniesDepartment){
    if(department){
      this.parentSelected = department;
    } else {
      this.parentSelected = undefined;
    }

  }

  formReset(){
    if (this.companiesDepartmentSelected) {
      this.preselectForm()
      this.parentDepartments = this.departmentsList.filter(el => el.company.id === this.companiesDepartmentSelected?.company?.id && el.id !== this.companiesDepartmentSelected.id);
      this.form = this.formBuilder.group({
        company : [this.companySelected,Validators.required],
        name : [this.typeSelected.name, [Validators.required,Validators.maxLength(50)]],
        description : [this.typeSelected.description,[Validators.required,Validators.maxLength(255)]],
        parent : [this.parentSelected],
      })
    } else {
      this.form.reset();
    }
  }

  errorCheck() {
    this.errors = !this.form.valid;
  }

  onSave(){
    let requestBulk = {departmentId:null,joinId:null,name:null , description:null , parentId:null , companyId:null};
    requestBulk.companyId = this.companySelected.id;
    requestBulk.name = this.typeSelected.name;
    requestBulk.description = this.typeSelected.description;
    if(this.parentSelected){
      requestBulk.parentId = this.parentSelected.joinId;
    }
    if(this.companiesDepartmentSelected){
      requestBulk.joinId = this.companiesDepartmentSelected.joinId;
      requestBulk.departmentId = this.companiesDepartmentSelected.id;
    }
    this.dialogRef.close({data: requestBulk, save:true});
  }

  private preselectForm() {
    this.typeSelected = { id: '', name: '', description: '' }
    if (this.companiesDepartmentSelected) {
      let filtredTypes = this.types.filter(type => type.id === this.companiesDepartmentSelected.id);
      if (filtredTypes && filtredTypes.length > 0) {
        const typeFiltered = filtredTypes[0];
        this.typeSelected.id = typeFiltered.id;
        this.typeSelected.name = typeFiltered.name;
        this.typeSelected.description = typeFiltered.description;
      }

      let filtredCompanies = this.companiesList.filter(company => company.id === this.companiesDepartmentSelected.company.id);
      if (filtredCompanies && filtredCompanies.length > 0) {
        this.companySelected = filtredCompanies[0];
      }

      let filtredDepartments = this.departmentsList.filter(department => department.joinId === this.companiesDepartmentSelected.parentId);
      if (filtredDepartments && filtredDepartments.length > 0) {
        this.parentSelected = filtredDepartments[0];
      }
    }
  }

}
